import CompanyAvailabilityTableHeader from './CompanyAvailabilityTableHeader';

export default CompanyAvailabilityTableHeader;
